<!--
Sku列表

使用说明：

<Sku
 :sku="[{ProductSku}]"
 />


ProductSku={
  skuId: 0,
  name: 'Sku名称'
}

-->

<template>
    <div class="wrap">
        <div class="title">选择规格</div>
        <div class="sku-list">
          <div class="sku-item" :class="{selected: curr && curr.skuId == s.skuId}" v-for="s in sku" :key="'sku-'+s.skuId" @click="select(s)">
            {{s.name}}
          </div>
        </div>
    </div>
</template>

<script>
export default {
  props: ['sku'],
  data(){
    return {
      curr: null
    };
  },
  methods:{
    select(s){
      this.curr = s;
      this.$emit('onChange', s);
    }
  }
}
</script>

<style lang="less" scoped>
.wrap{
  position: relative;
  z-index: 13;
  color: #333333;
  padding-bottom: 2.6vw;
  max-height: 100%;
  overflow-y: auto;
  -webkit-overflow-scrolling : touch;

  .title{
    font-size: 3.6vw;
    padding-left: 4vw;
    line-height: 10.93vw;
  }

  .sku-list{
    padding: 0 3vw;
    .sku-item{
      display: inline-block;
      margin: 1.06vw;
      font-size: 3.06vw;
      background: #e5e5e5;
      line-height: 7.73vw;
      border-radius: 7.73vw / 2;
      text-align: center;
      padding: 0 3.73vw;

      &.selected{
        color: #fff;
        background: #ff9933;
      }
    }
  }
}
</style>






// WEBPACK FOOTER //
// src/components/products/form/Sku.vue